var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('AppHeader',{attrs:{"title":"마일리지 내역","is-history":"","is-page-info":""},on:{"info-click":function($event){return _vm.openModal('ModalMileage')}}}),_c('AppContent',[_c('MileageDetail')],1),_c('AppFooter'),(_vm.modalComp)?_c(_vm.modalComp,{tag:"component"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }